import { PropsWithChildren, Suspense } from "react"
import ErrorBoundary from "./ErrorBoundary"
import { SuspenseFallback } from "./SuspenseFallback"

interface SuspenseWithErrorBoundryProps {
    errorBoundryFallback?: React.ReactNode,
    suspenseFallback?: React.ReactNode
}
export const SuspenseWithErrorBoundry = ({
    children,
    errorBoundryFallback = <h4>En feil oppstod...! :(</h4>,
    suspenseFallback = <SuspenseFallback/>
}: PropsWithChildren<SuspenseWithErrorBoundryProps>) => {
    return (
        <ErrorBoundary fallback={errorBoundryFallback}>
            <Suspense fallback={suspenseFallback}>
                {children}
            </Suspense>
        </ErrorBoundary>
    )
}
